import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Stack, Typography, Icon, Menu, MenuItem, ListItemAvatar, ListItemText, Divider, ListItemIcon } from 'investira.react.components';
import { acCarteirasChanged, acPortfoliosChanged, acReportsEnquadramentosChanged, acEntidadeCurrentMembrosChanged } from '../../../store/actions';
import { EntidadeAvatar } from '../../molecules';
import { Logo } from '../../organisms';
import { PATHS } from '../../../enums';
import services from '../../../services';
import withResponseHandling from '../../../hoc/withResponseHandling';
import usePerfil from '../../../hooks/usePerfil';

/**
 * Renderiza o componente EntidadeShortcut.
 *
 * @param {Object} props - Propriedades do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const EntidadeShortcut = props => {
  const entidade = useSelector(state => state.entidade);
  const {
    usuarioPrioridade
  } = usePerfil();
  const sessionCurrentEntidade = sessionStorage.getItem('current_entidade');
  const sessionCurrentEntidadeId = sessionStorage.getItem('current_entidade_id');
  const storeDispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const hasMenu = entidade.data.length > 0; //1

  function trocaEntidade(pEntidadeId) {
    services.user.entidade(pEntidadeId, rRes => {
      //Tudo que precisar ser renovado ao trocar entidade entra aqui (ex.: carteiras na store)

      //CARTEIRAS
      services.carteiras.list({
        favorito: 1
      }, rRes => {
        // Atualiza o estado do Redux com as carteiras
        storeDispatch(acCarteirasChanged(rRes.data));
      }, rErr => {
        props.responseErrorHandling(rErr);
      });

      //PORTFOLIOS
      services.portfolios.list({}, rRes => {
        // Atualiza o estado do Redux com os portfolios
        storeDispatch(acPortfoliosChanged(rRes.data));
      }, rErr => {
        props.responseErrorHandling(rErr);
      });

      //ENQUADRAMENTO
      services.enquadramentos.list({}, rRes => {
        // Atualiza o estado do Redux com as definições de enquadramento
        storeDispatch(acReportsEnquadramentosChanged(rRes.data));
      }, rErr => {
        props.responseErrorHandling(rErr);
      });

      // MEMBROS
      services.entidadesUsuario.list({}, rRes => {
        // Atualiza o estado do Redux com os membros
        storeDispatch(acEntidadeCurrentMembrosChanged(rRes.data));
      }, rErr => {
        props.responseErrorHandling(rErr);
      });
    }, rErr => {
      props.responseErrorHandling(rErr);
    });
  }
  const hideCurrentEntidade = (pEntidades, pCurrentEntidadeId) => {
    return pEntidades.filter(xEntidade => {
      return xEntidade.entidade_id !== pCurrentEntidadeId;
    });
  };
  function handleEntidadeClick(pEntidadeId) {
    trocaEntidade(pEntidadeId);
  }
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  if (!hasMenu) {
    return <Stack direction="row" alignItems="center" spacing={1} sx={{
      px: 1,
      py: 1
    }}>
        <Typography variant="caption" color="text.secondary" sx={{
        fontWeight: 600
      }}>
          {entidade.current.entidade}
        </Typography>
      </Stack>;
  }
  return <>
      <Stack direction="row" alignItems="center" spacing={1} sx={{
      cursor: 'pointer',
      px: {
        xs: 0.5,
        sm: 1
      },
      py: {
        xs: 0.5,
        sm: 1
      },
      marginLeft: '-8px !important',
      borderRadius: 2,
      '&:hover': {
        backgroundColor: '#2e2e46'
      }
    }} onClick={handleClick}>
        <Stack sx={{
        backgroundColor: 'secondary.main',
        width: '24px',
        height: '24px',
        borderRadius: 2,
        justifyContent: 'center',
        alignItems: 'center'
      }}>
          {/* <Icon iconName="parthenon" color="textSecondary" size={14} /> */}
          <Logo isLoggedIn={props.isLoggedIn} sx={{
          height: '24px',
          width: '24px'
        }} />
        </Stack>
        <Typography variant="caption" color="textPrimary" sx={{
        fontWeight: 600,
        maxWidth: {
          xs: '80px',
          sm: '100%'
        },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
          {sessionCurrentEntidade || entidade.current.entidade}
        </Typography>
        <Icon iconName={open ? 'arrow-up' : 'arrow-down'} size={11} color="primary" />
      </Stack>

      <Menu anchorEl={anchorEl} id="account-menu" open={open} onClose={handleClose} onClick={handleClose} transformOrigin={{
      horizontal: 'left',
      vertical: 'top'
    }} anchorOrigin={{
      horizontal: 'left',
      vertical: 'bottom'
    }}>
        {/* Entidade atual */}
        <Stack sx={{
        py: 2
      }}>
          <Stack sx={{
          px: 2,
          mb: 2,
          alignItems: 'center',
          gap: 2
        }}>
            <Logo isLoggedIn={props.isLoggedIn} />
            <Typography color="textPrimary" variant="subtitle" sx={{
            fontWeight: 600
          }}>
              {sessionCurrentEntidade || entidade.current.entidade}
            </Typography>
          </Stack>
          <Stack>
            <MenuItem component={Link} to={'/configuracoes' + PATHS.configuracoes.nested.entidades.nested.membros.path}>
              <ListItemIcon>
                <Icon iconName="users" color="primary" size={14} />
              </ListItemIcon>
              <ListItemText primary={'Membros'} primaryTypographyProps={{
              variant: 'caption'
            }} />
            </MenuItem>
            {usuarioPrioridade <= 2 && <MenuItem component={Link} to={'/configuracoes' + PATHS.configuracoes.nested['fundos-fechados'].path}>
                <ListItemIcon>
                  <Icon iconName="fund" color="primary" size={14} />
                </ListItemIcon>
                <ListItemText primary={'Fundos Excepcionalmente não Abertos'} primaryTypographyProps={{
              variant: 'caption'
            }} />
              </MenuItem>}
            {usuarioPrioridade <= 2 && <MenuItem component={Link} to={'/configuracoes' + PATHS.configuracoes.nested['benchmarks'].path}>
                <ListItemIcon>
                  <Icon iconName="chart_line" color="primary" size={14} />
                </ListItemIcon>
                <ListItemText primary={'Benchmarks'} primaryTypographyProps={{
              variant: 'caption'
            }} />
              </MenuItem>}
          </Stack>
        </Stack>

        <Divider />
        {/* Outras Entidades */}
        <Stack sx={{
        py: 2
      }}>
          {/* <ListSubheader>Minhas Entidades</ListSubheader> */}
          {hideCurrentEntidade(entidade.data, sessionCurrentEntidadeId || entidade.current.default_entidade_id).map((xEntidade, xIndex) => {
          return <MenuItem key={`${xEntidade.entidade}-${xIndex}`} onClick={() => handleEntidadeClick(xEntidade.entidade_id)}>
                <ListItemAvatar>
                  <EntidadeAvatar alt={xEntidade.entidade} sx={{
                width: 24,
                height: 24
              }} sizeLetters={1} entidadeId={xEntidade.entidade_id} />
                </ListItemAvatar>
                <ListItemText primary={xEntidade.entidade} primaryTypographyProps={{
              variant: 'caption'
            }} />
              </MenuItem>;
        })}
        </Stack>
      </Menu>
    </>;
};
EntidadeShortcut.propTypes = {};
EntidadeShortcut.displayName = 'EntidadeShortcut';
export default withResponseHandling(EntidadeShortcut);
